import React from 'react';
import { Phone } from 'lucide-react';
import { garageInfo, garageImages } from '../data/mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center pt-32 pb-16">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={garageImages.hero}
          alt="Garage 1225 Sàrl - Atelier professionnel à Chêne-Bourg"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-sky-900/80"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="inline-block bg-sky-500/20 backdrop-blur-sm border border-sky-400/30 rounded-full px-4 py-2 mb-6">
            <span className="text-sky-300 text-sm font-medium">Votre garage de confiance à Chêne-Bourg</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Garage 1225
            <span className="block text-sky-400 mt-2">à Votre Service</span>
          </h1>
          
          <p className="text-lg md:text-xl text-slate-200 mb-8 leading-relaxed">
            Mécanique générale, diagnostic, entretien et préparation à l'expertise. 
            Des professionnels qualifiés pour prendre soin de votre véhicule.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button
              onClick={() => scrollToSection('contact')}
              className="group bg-gradient-to-r from-sky-500 to-sky-600 text-white px-8 py-4 rounded-lg font-semibold hover:from-sky-600 hover:to-sky-700 transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            >
              <Phone size={20} />
              Nous Contacter
            </button>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4">
              <div className="text-sky-400 text-2xl font-bold mb-1">10+</div>
              <div className="text-white text-sm">Années d'Expérience</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4">
              <div className="text-sky-400 text-2xl font-bold mb-1">500+</div>
              <div className="text-white text-sm">Clients Satisfaits</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4">
              <div className="text-sky-400 text-2xl font-bold mb-1">✓</div>
              <div className="text-white text-sm">Travail Soigné</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-slate-50 to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
